import type { BlockVariableConfig } from '../types'

export type DummyBlockProperties = never

/**
 * Dummy blocks do not have a particular set of variables,
 * as they display variables from blocks which came before them.
 */
export const getVariablesFromDummyBlock = (): BlockVariableConfig => ({
  properties: [],
  isAccessedByIndex: false
})

export const getValuesFromDummyBlock = () => ({})
